import * as React from 'react';
import styled from 'styled-components';
import { color, Text } from '@starrez/starryui9';

interface IFieldsetProps {
    caption: string;
}

export const Fieldset: React.FC<IFieldsetProps> = ({ caption, children }) => (
    <FieldSetContainer>
        <FieldSetLegend>
            <Text color={color.Grey.G80} variant="large.bold">
                {caption}
            </Text>
        </FieldSetLegend>
        {children}
    </FieldSetContainer>
);

const FieldSetContainer = styled.fieldset`
    padding: 0;
    border: 0;
    margin: 0;
`;

const FieldSetLegend = styled.legend`
    padding-bottom: 16px;
`;
